import { render, staticRenderFns } from "./EditMyBusiness.vue?vue&type=template&id=6c201f0d&"
import script from "./EditMyBusiness.vue?vue&type=script&lang=js&"
export * from "./EditMyBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports